// カード詳細表示 (= DDSIM-27 Pass 3) 用の context。
//
// catalog (card_id -> CardDefDto) と「今 hover 中のカード」を共有し、
// CardTile が hover を通知 / CardDetail が詳細を描画する (= prop drilling 回避)。

import { createContext, useContext, useState, type ReactNode } from "react";

import type { CardDefDto } from "@/bindings/CardDefDto";

interface CardCatalogValue {
  byId: Map<number, CardDefDto>;
  hoveredId: number | null;
  setHoveredId: (id: number | null) => void;
}

const CardCatalogContext = createContext<CardCatalogValue | null>(null);

export function CardCatalogProvider(props: {
  byId: Map<number, CardDefDto>;
  children: ReactNode;
}): JSX.Element {
  const { byId, children } = props;
  const [hoveredId, setHoveredId] = useState<number | null>(null);
  return (
    <CardCatalogContext.Provider value={{ byId, hoveredId, setHoveredId }}>
      {children}
    </CardCatalogContext.Provider>
  );
}

export function useCardCatalog(): CardCatalogValue {
  const ctx = useContext(CardCatalogContext);
  if (ctx === null) {
    throw new Error("useCardCatalog は CardCatalogProvider 内で使うこと");
  }
  return ctx;
}
